var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"section-type"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"list",on:{"click":function($event){return _vm.redirect(item.url)}}},[_c('img',{attrs:{"src":item.icon,"alt":""}}),_c('p',[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }